<mat-dialog-content>
  <div>
    <span style="font-size: 16px;" class="d-flex justify-content-end">
      <i (click)="onDismiss()" style="cursor: pointer" class="ms-Icon ms-Icon&#45;&#45;Cancel"></i>
    </span>
  </div>
  <p style="text-align: center; font-size: 14px">
    {{ (dialogData.isDomain ? 'sender.trust_domain_dialog' : 'sender.trust_email_dialog') | translate:translateParam}}
  </p>
  <div *ngIf="dialogData.isDomain">
    <mat-form-field appearance="outline" class="small-mat-form">
      <input matInput type="text" placeholder="{{'sender.company_name_placeholder' | translate}}"
             [(ngModel)]="dialogData.data.company_name" required>
    </mat-form-field>
  </div>

  <div class="d-flex justify-content-center">
    <button class="phish-primary-btn" style="padding-top: 5px !important; padding-bottom: 5px!important; font-size: 14px;"
            (click)="submit()" [disabled]="isSubmitDisabled()">
      {{ 'sender.add_to_trusted_list_btn' | translate }} {{(dialogData.isDomain ? 'sender.domain' : 'sender.email') | translate}} List
    </button>
  </div>
</mat-dialog-content>
